import { PlanType } from './../../enums/user/plan-type.enum';
export class PlanTypeAction {
  id: number;
  actionId: number;
  planType: PlanType;
  isActive: boolean;

  constructor() {
    this.id = 0;
    this.actionId = 0;
    this.planType = PlanType.Unknown;
    this.isActive = false;
  }
}
